import { createWebHistory, createRouter } from 'vue-router'

// Layouts
import App from '@layouts/App.vue'

// Pages
import Index from '@pages/Index.vue'
import Event from '@pages/Event.vue'
import Error from '@pages/Error.vue'

// Account
import Events from '@pages/user/Events.vue'

// Routes
const routes = [
	{
		path: '/',
		component: App,
		children: [
			{ path: '', name: 'index', component: Index },
			{ path: 'event/:slug', name: 'event', component: Event },
			{
				path: 'account',
				children: [{ path: 'events', name: 'account.events', component: Events }],
			},
			{ path: 'error/:type', name: 'error', component: Error },
			{
				path: '/:catchAll(.*)',
				name: '404',
				component: Error,
				meta: { type: '404' },
			},
		],
	},
]

const router = createRouter({
	scrollBehavior(to, from, savedPosition) {
		if (to.name == from.name && !to.hash) {
			return { top: 0, behavior: 'smooth' }
		} else if (to.hash) {
			return {
				el: to.hash,
				top: 100,
				behavior: 'smooth',
			}
		} else {
			return {
				top: 0,
			}
		}
	},
	history: createWebHistory(),
	routes,
})

export default router
